import { Icon, IconsEnum } from 'components/Icons';
import { selectSaldoPrelevabile, selectWalletFetchStatus } from 'features/dashboard/selectors';
import { useEffect } from 'react';
import { getWallet } from 'features/dashboard/action';
import { setIsOpenLoginModalValue } from 'features/modal/modalSlice';
import styles from './ChatTrigger.module.scss';
import { useAppDispatch } from 'lib/centralStore';
import { useInternalSession } from 'hooks/useInternalSession';
import { useTypedSelector } from 'sites/snai/lib/store';
import { useWebchatAnonymius, useWebchatLogin } from 'hooks/useWebchat';
import classNames from 'classnames';

export type ChatTriggerProps = {
  text?: string;
  isChatForAuthenticated?: boolean;
  className?: string;
};

export const ChatTrigger = ({ text, isChatForAuthenticated = false, className }: ChatTriggerProps) => {
  const { isAuthenticated } = useInternalSession();

  const dispatch = useAppDispatch();

  const saldoPrelevabile = useTypedSelector(selectSaldoPrelevabile);
  const { isWalletUninitialized } = useTypedSelector(selectWalletFetchStatus);

  useEffect(() => {
    if ((isWalletUninitialized || !saldoPrelevabile) && isAuthenticated) {
      dispatch(getWallet({ ts: new Date() }));
    }
  }, [isWalletUninitialized, isAuthenticated, dispatch, saldoPrelevabile]);

  const { onOpen: onOpenLogged } = useWebchatLogin();

  const { onOpen: onOpenAnonymius } = useWebchatAnonymius();

  return (
    <button
      className={classNames(styles.container, className ?? '')}
      onClick={() => {
        if (!isChatForAuthenticated) {
          onOpenAnonymius();
        } else if (isAuthenticated) {
          onOpenLogged();
        } else {
          dispatch(setIsOpenLoginModalValue(true));
          onOpenLogged();
        }
      }}
    >
      <div>
        <Icon iconId={IconsEnum.COMMENT} className={styles.icon} color="var(--color-bg)" />
      </div>
      {text && <span>{text}</span>}
    </button>
  );
};
